<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-08 10:25:54
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2019-07-20 14:23:33
 * @Description: file content
 免责声明
 -->
 <template>
  <div class="container">
    <div class="warp1">
      <div class="btn" @click="clickBtn">
        <img
          class="icon_info"
          src="https://assets.rurushishi.com/yq-rs-make/components/found_disclaimer/icon_info.png"
          alt
        />
        <span>免责声明</span>
        <img
          class="icon_arrow"
          src="https://assets.rurushishi.com/yq-rs-make/components/found_disclaimer/icon_arrow.png"
          alt
        />
      </div>
    </div>

    <!-- <div class="arrow-up"></div> -->
    <div class="bubble animated fadeInUp" v-if="isShowBubble">
      该文章由很多客的用户自主上传，文字版权归原作者所有，如果您发现内容存在版权问题，请点击
      <span class="complaint" @click="clickComplaint">投诉</span> 提交您的联系方式及投诉内容，我们将及时处理。谢谢！
    </div>
  </div>
</template>
 
 <script>
export default {
  components: {},
  props: {},
  data() {
    return {
      isShowBubble: false
    };
  },
  watch: {},
  computed: {},
  methods: {
    clickBtn() {
      this.isShowBubble = !this.isShowBubble;
    },
    clickComplaint() {
      this.$router.push("/hdk/complaint");
    }
  },
  created() {},
  mounted() {}
};
</script>
 <style lang="css" scoped>
.container {
  margin: 0.3rem;
  margin-top: 0;
  color: #999999;
  font-size: 12px;
}
.warp1 {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.btn {
  width: 88px;
}
.btn .icon_info {
  width: 12px;
  padding-right: 5px;
  margin-top: -2px;
}
.btn .icon_arrow {
  width: 25px;
  margin-top: -2px;
  margin-left: -2px;
}
.bubble {
  background-color: #f6f7fb;
  color: #929292;
  border-radius: 10px;
  padding: 10px;
  line-height: 20px;
  position: relative;
  margin-top: 5px;
  animation-fill-mode: both;
}

.bubble:after {
  position: absolute;
  top: -5px;
  right: 40px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 5px solid #f6f7fb;
  font-size: 0;
  line-height: 0;
  content: " ";
}
.bubble .complaint {
  color: #3597f8;
  text-decoration: underline;
}
</style>
